<div class="tooltip-box">
  {{ text }}
</div>